import {LANGUAGE_CHANGED} from './actionTypes';

export const changeLanguage = language => ({
  type: LANGUAGE_CHANGED,
  payload: {language},
});
